export const TIMEZONES = [
	{
		value: 'Dateline Standard Time',
		abbr: 'DST',
		offset: -12,
		isdst: false,
		text: '(UTC-12:00) International Date Line West',
		text2: 'DST - Dateline Standard Time',
		utc: ['Etc/GMT+12'],
	},
	{
		value: 'UTC-11',
		abbr: 'U',
		offset: -11,
		isdst: false,
		text: '(UTC-11:00) Coordinated Universal Time-11',
		text2: 'U - UTC-11',
		utc: [
			'Etc/GMT+11',
			'Pacific/Midway',
			'Pacific/Niue',
			'Pacific/Pago_Pago',
		],
	},
	{
		value: 'Hawaiian Standard Time',
		abbr: 'HST',
		offset: -10,
		isdst: false,
		text: '(UTC-10:00) Hawaii',
		text2: 'HST - Hawaiian Standard Time',
		utc: [
			'Etc/GMT+10',
			'Pacific/Honolulu',
			'Pacific/Johnston',
			'Pacific/Rarotonga',
			'Pacific/Tahiti',
		],
	},
	{
		value: 'Alaskan Standard Time',
		abbr: 'AKDT',
		offset: -8,
		isdst: true,
		text: '(UTC-09:00) Alaska',
		text2: 'AKDT - Alaskan Standard Time',
		utc: [
			'America/Anchorage',
			'America/Juneau',
			'America/Nome',
			'America/Sitka',
			'America/Yakutat',
		],
	},
	{
		value: 'Pacific Standard Time (Mexico)',
		abbr: 'PDT',
		offset: -7,
		isdst: true,
		text: '(UTC-08:00) Baja California',
		text2: 'PDT - Pacific Standard Time (Mexico)',
		utc: ['America/Santa_Isabel'],
	},
	{
		value: 'Pacific Daylight Time',
		abbr: 'PDT',
		offset: -7,
		isdst: true,
		text: '(UTC-07:00) Pacific Daylight Time (US & Canada)',
		text2: 'PDT - Pacific Daylight Time',
		utc: ['America/Los_Angeles', 'America/Tijuana', 'America/Vancouver'],
	},
	{
		value: 'Pacific Standard Time',
		abbr: 'PST',
		offset: -8,
		isdst: false,
		text: '(UTC-08:00) Pacific Standard Time (US & Canada)',
		text2: 'PST - Pacific Standard Time',
		utc: [
			'America/Los_Angeles',
			'America/Tijuana',
			'America/Vancouver',
			'PST8PDT',
		],
	},
	{
		value: 'US Mountain Standard Time',
		abbr: 'UMST',
		offset: -7,
		isdst: false,
		text: '(UTC-07:00) Arizona',
		text2: 'UMST - US Mountain Standard Time',
		utc: [
			'America/Creston',
			'America/Dawson',
			'America/Dawson_Creek',
			'America/Hermosillo',
			'America/Phoenix',
			'America/Whitehorse',
			'Etc/GMT+7',
		],
	},
	{
		value: 'Mountain Standard Time (Mexico)',
		abbr: 'MDT',
		offset: -6,
		isdst: true,
		text: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
		text2: 'MDT - Mountain Standard Time (Mexico)',
		utc: ['America/Chihuahua', 'America/Mazatlan'],
	},
	{
		value: 'Mountain Standard Time',
		abbr: 'MDT',
		offset: -6,
		isdst: true,
		text: '(UTC-07:00) Mountain Time (US & Canada)',
		text2: 'MDT - Mountain Standard Time',
		utc: [
			'America/Boise',
			'America/Cambridge_Bay',
			'America/Denver',
			'America/Edmonton',
			'America/Inuvik',
			'America/Ojinaga',
			'America/Yellowknife',
			'MST7MDT',
		],
	},
	{
		value: 'Central America Standard Time',
		abbr: 'CAST',
		offset: -6,
		isdst: false,
		text: '(UTC-06:00) Central America',
		text2: 'CAST - Central America Standard Time',
		utc: [
			'America/Belize',
			'America/Costa_Rica',
			'America/El_Salvador',
			'America/Guatemala',
			'America/Managua',
			'America/Tegucigalpa',
			'Etc/GMT+6',
			'Pacific/Galapagos',
		],
	},
	{
		value: 'Central Standard Time',
		abbr: 'CDT',
		offset: -5,
		isdst: true,
		text: '(UTC-06:00) Central Time (US & Canada)',
		text2: 'CDT - Central Standard Time',
		utc: [
			'America/Chicago',
			'America/Indiana/Knox',
			'America/Indiana/Tell_City',
			'America/Matamoros',
			'America/Menominee',
			'America/North_Dakota/Beulah',
			'America/North_Dakota/Center',
			'America/North_Dakota/New_Salem',
			'America/Rainy_River',
			'America/Rankin_Inlet',
			'America/Resolute',
			'America/Winnipeg',
			'CST6CDT',
		],
	},
	{
		value: 'Central Standard Time (Mexico)',
		abbr: 'CDT',
		offset: -5,
		isdst: true,
		text: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
		text2: 'CDT - Central Standard Time (Mexico)',
		utc: [
			'America/Bahia_Banderas',
			'America/Cancun',
			'America/Merida',
			'America/Mexico_City',
			'America/Monterrey',
		],
	},
	{
		value: 'Canada Central Standard Time',
		abbr: 'CCST',
		offset: -6,
		isdst: false,
		text: '(UTC-06:00) Saskatchewan',
		text2: 'CCST - Canada Central Standard Time',
		utc: ['America/Regina', 'America/Swift_Current'],
	},
	{
		value: 'SA Pacific Standard Time',
		abbr: 'SPST',
		offset: -5,
		isdst: false,
		text: '(UTC-05:00) Bogota, Lima, Quito',
		text2: 'SPST - SA Pacific Standard Time',
		utc: [
			'America/Bogota',
			'America/Cayman',
			'America/Coral_Harbour',
			'America/Eirunepe',
			'America/Guayaquil',
			'America/Jamaica',
			'America/Lima',
			'America/Panama',
			'America/Rio_Branco',
			'Etc/GMT+5',
		],
	},
	{
		value: 'Eastern Standard Time',
		abbr: 'EST',
		offset: -5,
		isdst: false,
		text: '(UTC-05:00) Eastern Time (US & Canada)',
		text2: 'EST - Eastern Standard Time',
		utc: [
			'America/Detroit',
			'America/Havana',
			'America/Indiana/Petersburg',
			'America/Indiana/Vincennes',
			'America/Indiana/Winamac',
			'America/Iqaluit',
			'America/Kentucky/Monticello',
			'America/Louisville',
			'America/Montreal',
			'America/Nassau',
			'America/New_York',
			'America/Nipigon',
			'America/Pangnirtung',
			'America/Port-au-Prince',
			'America/Thunder_Bay',
			'America/Toronto',
		],
	},
	{
		value: 'Eastern Daylight Time',
		abbr: 'EDT',
		offset: -4,
		isdst: true,
		text: '(UTC-04:00) Eastern Daylight Time (US & Canada)',
		text2: 'EDT - Eastern Daylight Time',
		utc: [
			'America/Detroit',
			'America/Havana',
			'America/Indiana/Petersburg',
			'America/Indiana/Vincennes',
			'America/Indiana/Winamac',
			'America/Iqaluit',
			'America/Kentucky/Monticello',
			'America/Louisville',
			'America/Montreal',
			'America/Nassau',
			'America/New_York',
			'America/Nipigon',
			'America/Pangnirtung',
			'America/Port-au-Prince',
			'America/Thunder_Bay',
			'America/Toronto',
		],
	},
	{
		value: 'US Eastern Standard Time',
		abbr: 'UEDT',
		offset: -5,
		isdst: false,
		text: '(UTC-05:00) Indiana (East)',
		text2: 'UEDT - US Eastern Standard Time',
		utc: [
			'America/Indiana/Marengo',
			'America/Indiana/Vevay',
			'America/Indianapolis',
		],
	},
	{
		value: 'Venezuela Standard Time',
		abbr: 'VST',
		offset: -4.5,
		isdst: false,
		text: '(UTC-04:30) Caracas',
		text2: 'VST - Venezuela Standard Time',
		utc: ['America/Caracas'],
	},
	{
		value: 'Paraguay Standard Time',
		abbr: 'PYT',
		offset: -4,
		isdst: false,
		text: '(UTC-04:00) Asuncion',
		text2: 'PYT - Paraguay Standard Time',
		utc: ['America/Asuncion'],
	},
	{
		value: 'Atlantic Standard Time',
		abbr: 'AST',
		offset: -4,
		isdst: false,
		text: '(UTC-04:00) Atlantic Standard Time (North America, Atlantic, Caribbean)',
		text2: 'AST - Atlantic Standard Time',
		utc: [
			'America/Blanc-Sablon',
			'America/Glace_Bay',
			'America/Goose_Bay',
			'America/Halifax',
			'America/Moncton',
			'America/Thule',
			'Atlantic/Bermuda',
		],
	},
	{
		value: 'Atlantic Daylight Time',
		abbr: 'ADT',
		offset: -3,
		isdst: true,
		text: '(UTC-04:00) Atlantic Time (Canada)',
		text2: 'ADT - Atlantic Standard Time',
		utc: [
			'America/Glace_Bay',
			'America/Goose_Bay',
			'America/Halifax',
			'America/Moncton',
			'America/Thule',
			'Atlantic/Bermuda',
		],
	},
	{
		value: 'Central Brazilian Standard Time',
		abbr: 'CBST',
		offset: -4,
		isdst: false,
		text: '(UTC-04:00) Cuiaba',
		text2: 'CBST - Central Brazilian Standard Time',
		utc: ['America/Campo_Grande', 'America/Cuiaba'],
	},
	{
		value: 'SA Western Standard Time',
		abbr: 'SWST',
		offset: -4,
		isdst: false,
		text: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
		text2: 'SWST - SA Western Standard Time',
		utc: [
			'America/Anguilla',
			'America/Antigua',
			'America/Aruba',
			'America/Barbados',
			'America/Blanc-Sablon',
			'America/Boa_Vista',
			'America/Curacao',
			'America/Dominica',
			'America/Grand_Turk',
			'America/Grenada',
			'America/Guadeloupe',
			'America/Guyana',
			'America/Kralendijk',
			'America/La_Paz',
			'America/Lower_Princes',
			'America/Manaus',
			'America/Marigot',
			'America/Martinique',
			'America/Montserrat',
			'America/Port_of_Spain',
			'America/Porto_Velho',
			'America/Puerto_Rico',
			'America/Santo_Domingo',
			'America/St_Barthelemy',
			'America/St_Kitts',
			'America/St_Lucia',
			'America/St_Thomas',
			'America/St_Vincent',
			'America/Tortola',
			'Etc/GMT+4',
		],
	},
	{
		value: 'Pacific SA Standard Time',
		abbr: 'PSST',
		offset: -4,
		isdst: false,
		text: '(UTC-04:00) Santiago',
		text2: 'PSST - Pacific SA Standard Time',
		utc: ['America/Santiago', 'Antarctica/Palmer'],
	},
	{
		value: 'Newfoundland Standard Time',
		abbr: 'NDT',
		offset: -2.5,
		isdst: true,
		text: '(UTC-03:30) Newfoundland',
		text2: 'NDT - Newfoundland Standard Time',
		utc: ['America/St_Johns'],
	},
	{
		value: 'E. South America Standard Time',
		abbr: 'ESAST',
		offset: -3,
		isdst: false,
		text: '(UTC-03:00) Brasilia',
		text2: 'ESAST - E. South America Standard Time',
		utc: ['America/Sao_Paulo'],
	},
	{
		value: 'Argentina Standard Time',
		abbr: 'ASTA',
		offset: -3,
		isdst: false,
		text: '(UTC-03:00) Buenos Aires',
		text2: 'AST - Argentina Standard Time',
		utc: [
			'America/Argentina/La_Rioja',
			'America/Argentina/Rio_Gallegos',
			'America/Argentina/Salta',
			'America/Argentina/San_Juan',
			'America/Argentina/San_Luis',
			'America/Argentina/Tucuman',
			'America/Argentina/Ushuaia',
			'America/Buenos_Aires',
			'America/Catamarca',
			'America/Cordoba',
			'America/Jujuy',
			'America/Mendoza',
		],
	},
	{
		value: 'SA Eastern Standard Time',
		abbr: 'SEST',
		offset: -3,
		isdst: false,
		text: '(UTC-03:00) Cayenne, Fortaleza',
		text2: 'SEST - SA Eastern Standard Time',
		utc: [
			'America/Araguaina',
			'America/Belem',
			'America/Cayenne',
			'America/Fortaleza',
			'America/Maceio',
			'America/Paramaribo',
			'America/Recife',
			'America/Santarem',
			'Antarctica/Rothera',
			'Atlantic/Stanley',
			'Etc/GMT+3',
		],
	},
	{
		value: 'Greenland Standard Time',
		abbr: 'GDT',
		offset: -3,
		isdst: true,
		text: '(UTC-03:00) Greenland',
		text2: 'GDT - Greenland Standard Time',
		utc: ['America/Godthab'],
	},
	{
		value: 'Montevideo Standard Time',
		abbr: 'MST',
		offset: -3,
		isdst: false,
		text: '(UTC-03:00) Montevideo',
		text2: 'MST - Montevideo Standard Time',
		utc: ['America/Montevideo'],
	},
	{
		value: 'Bahia Standard Time',
		abbr: 'BST',
		offset: -3,
		isdst: false,
		text: '(UTC-03:00) Salvador',
		text2: 'BST - Bahia Standard Time',
		utc: ['America/Bahia'],
	},
	{
		value: 'UTC-02',
		abbr: 'U',
		offset: -2,
		isdst: false,
		text: '(UTC-02:00) Coordinated Universal Time-02',
		text2: 'U - UTC-02',
		utc: ['America/Noronha', 'Atlantic/South_Georgia', 'Etc/GMT+2'],
	},
	{
		value: 'Mid-Atlantic Standard Time',
		abbr: 'MDT',
		offset: -1,
		isdst: true,
		text: '(UTC-02:00) Mid-Atlantic - Old',
		text2: 'MDT - Mid-Atlantic Standard Time',
		utc: [],
	},
	{
		value: 'Azores Standard Time',
		abbr: 'ADT',
		offset: 0,
		isdst: true,
		text: '(UTC-01:00) Azores',
		text2: 'ADT - Azores Standard Time',
		utc: ['America/Scoresbysund', 'Atlantic/Azores'],
	},
	{
		value: 'Cape Verde Standard Time',
		abbr: 'CVST',
		offset: -1,
		isdst: false,
		text: '(UTC-01:00) Cape Verde Is.',
		text2: 'CVST - Cape Verde Standard Time',
		utc: ['Atlantic/Cape_Verde', 'Etc/GMT+1'],
	},
	{
		value: 'Morocco Standard Time',
		abbr: 'MDT',
		offset: 1,
		isdst: true,
		text: '(UTC) Casablanca',
		text2: 'MDT - Morocco Standard Time',
		utc: ['Africa/Casablanca', 'Africa/El_Aaiun'],
	},
	{
		value: 'UTC',
		abbr: 'UTC',
		offset: 0,
		isdst: false,
		text: '(UTC) Coordinated Universal Time',
		text2: 'UTC - UTC',
		utc: ['America/Danmarkshavn', 'Etc/GMT'],
	},
	{
		value: 'GMT Standard Time',
		abbr: 'GMT',
		offset: 0,
		isdst: false,
		text: '(UTC) Edinburgh, London',
		text2: 'GMT - GMT Standard Time',
		utc: [
			'Europe/Isle_of_Man',
			'Europe/Guernsey',
			'Europe/Jersey',
			'Europe/London',
		],
	},
	{
		value: 'British Summer Time',
		abbr: 'BST',
		offset: 1,
		isdst: true,
		text: '(UTC+01:00) Edinburgh, London',
		text2: 'BST - British Summer Time',
		utc: [
			'Europe/Isle_of_Man',
			'Europe/Guernsey',
			'Europe/Jersey',
			'Europe/London',
		],
	},
	{
		value: 'GMT Standard Time',
		abbr: 'GDT',
		offset: 1,
		isdst: true,
		text: '(UTC) Dublin, Lisbon',
		text2: 'GDT - GMT Standard Time',
		utc: [
			'Atlantic/Canary',
			'Atlantic/Faeroe',
			'Atlantic/Madeira',
			'Europe/Dublin',
			'Europe/Lisbon',
		],
	},
	{
		value: 'Greenwich Standard Time',
		abbr: 'GST',
		offset: 0,
		isdst: false,
		text: '(UTC) Monrovia, Reykjavik',
		text2: 'GST - Greenwich Standard Time',
		utc: [
			'Africa/Abidjan',
			'Africa/Accra',
			'Africa/Bamako',
			'Africa/Banjul',
			'Africa/Bissau',
			'Africa/Conakry',
			'Africa/Dakar',
			'Africa/Freetown',
			'Africa/Lome',
			'Africa/Monrovia',
			'Africa/Nouakchott',
			'Africa/Ouagadougou',
			'Africa/Sao_Tome',
			'Atlantic/Reykjavik',
			'Atlantic/St_Helena',
		],
	},
	{
		value: 'W. Europe Standard Time',
		abbr: 'WEDT',
		offset: 2,
		isdst: true,
		text: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
		text2: 'WEDT - W. Europe Standard Time',
		utc: [
			'Arctic/Longyearbyen',
			'Europe/Amsterdam',
			'Europe/Andorra',
			'Europe/Berlin',
			'Europe/Busingen',
			'Europe/Gibraltar',
			'Europe/Luxembourg',
			'Europe/Malta',
			'Europe/Monaco',
			'Europe/Oslo',
			'Europe/Rome',
			'Europe/San_Marino',
			'Europe/Stockholm',
			'Europe/Vaduz',
			'Europe/Vatican',
			'Europe/Vienna',
			'Europe/Zurich',
		],
	},
	{
		value: 'Central Europe Standard Time',
		abbr: 'CEDT',
		offset: 2,
		isdst: true,
		text: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
		text2: 'CEDT - Central Europe Standard Time',
		utc: [
			'Europe/Belgrade',
			'Europe/Bratislava',
			'Europe/Budapest',
			'Europe/Ljubljana',
			'Europe/Podgorica',
			'Europe/Prague',
			'Europe/Tirane',
		],
	},
	{
		value: 'Romance Standard Time',
		abbr: 'RDT',
		offset: 2,
		isdst: true,
		text: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
		text2: 'RDT - Romance Standard Time',
		utc: [
			'Africa/Ceuta',
			'Europe/Brussels',
			'Europe/Copenhagen',
			'Europe/Madrid',
			'Europe/Paris',
		],
	},
	{
		value: 'Central European Standard Time',
		abbr: 'CEDT',
		offset: 2,
		isdst: true,
		text: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
		text2: 'CEDT - Central European Standard Time',
		utc: [
			'Europe/Sarajevo',
			'Europe/Skopje',
			'Europe/Warsaw',
			'Europe/Zagreb',
		],
	},
	{
		value: 'W. Central Africa Standard Time',
		abbr: 'WCAST',
		offset: 1,
		isdst: false,
		text: '(UTC+01:00) West Central Africa',
		text2: 'WCAST - W. Central Africa Standard Time',
		utc: [
			'Africa/Algiers',
			'Africa/Bangui',
			'Africa/Brazzaville',
			'Africa/Douala',
			'Africa/Kinshasa',
			'Africa/Lagos',
			'Africa/Libreville',
			'Africa/Luanda',
			'Africa/Malabo',
			'Africa/Ndjamena',
			'Africa/Niamey',
			'Africa/Porto-Novo',
			'Africa/Tunis',
			'Etc/GMT-1',
		],
	},
	{
		value: 'Namibia Standard Time',
		abbr: 'NST',
		offset: 1,
		isdst: false,
		text: '(UTC+01:00) Windhoek',
		text2: 'NST - Namibia Standard Time',
		utc: ['Africa/Windhoek'],
	},
	{
		value: 'GTB Standard Time',
		abbr: 'GDT',
		offset: 3,
		isdst: true,
		text: '(UTC+02:00) Athens, Bucharest',
		text2: 'GDT - GTB Standard Time',
		utc: [
			'Asia/Nicosia',
			'Europe/Athens',
			'Europe/Bucharest',
			'Europe/Chisinau',
		],
	},
	{
		value: 'Middle East Standard Time',
		abbr: 'MEDT',
		offset: 3,
		isdst: true,
		text: '(UTC+02:00) Beirut',
		text2: 'MEDT - Middle East Standard Time',
		utc: ['Asia/Beirut'],
	},
	{
		value: 'Egypt Standard Time',
		abbr: 'EST',
		offset: 2,
		isdst: false,
		text: '(UTC+02:00) Cairo',
		text2: 'EST - Egypt Standard Time',
		utc: ['Africa/Cairo'],
	},
	{
		value: 'Syria Standard Time',
		abbr: 'SDT',
		offset: 3,
		isdst: true,
		text: '(UTC+02:00) Damascus',
		text2: 'SDT - Syria Standard Time',
		utc: ['Asia/Damascus'],
	},
	{
		value: 'E. Europe Standard Time',
		abbr: 'EEDT',
		offset: 3,
		isdst: true,
		text: '(UTC+02:00) E. Europe',
		text2: 'EEDT - E. Europe Standard Time',
		utc: [
			'Asia/Nicosia',
			'Europe/Athens',
			'Europe/Bucharest',
			'Europe/Chisinau',
			'Europe/Helsinki',
			'Europe/Kiev',
			'Europe/Mariehamn',
			'Europe/Nicosia',
			'Europe/Riga',
			'Europe/Sofia',
			'Europe/Tallinn',
			'Europe/Uzhgorod',
			'Europe/Vilnius',
			'Europe/Zaporozhye',
		],
	},
	{
		value: 'South Africa Standard Time',
		abbr: 'SAST',
		offset: 2,
		isdst: false,
		text: '(UTC+02:00) Harare, Pretoria',
		text2: 'SAST - South Africa Standard Time',
		utc: [
			'Africa/Blantyre',
			'Africa/Bujumbura',
			'Africa/Gaborone',
			'Africa/Harare',
			'Africa/Johannesburg',
			'Africa/Kigali',
			'Africa/Lubumbashi',
			'Africa/Lusaka',
			'Africa/Maputo',
			'Africa/Maseru',
			'Africa/Mbabane',
			'Etc/GMT-2',
		],
	},
	{
		value: 'FLE Standard Time',
		abbr: 'FDT',
		offset: 3,
		isdst: true,
		text: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
		text2: 'FDT - FLE Standard Time',
		utc: [
			'Europe/Helsinki',
			'Europe/Kiev',
			'Europe/Mariehamn',
			'Europe/Riga',
			'Europe/Sofia',
			'Europe/Tallinn',
			'Europe/Uzhgorod',
			'Europe/Vilnius',
			'Europe/Zaporozhye',
		],
	},
	{
		value: 'Turkey Standard Time',
		abbr: 'TDT',
		offset: 3,
		isdst: false,
		text: '(UTC+03:00) Istanbul',
		text2: 'TDT - Turkey Standard Time',
		utc: ['Europe/Istanbul'],
	},
	{
		value: 'Israel Standard Time',
		abbr: 'JDT',
		offset: 3,
		isdst: true,
		text: '(UTC+02:00) Jerusalem',
		text2: 'JDT - Israel Standard Time',
		utc: ['Asia/Jerusalem'],
	},
	{
		value: 'Libya Standard Time',
		abbr: 'LST',
		offset: 2,
		isdst: false,
		text: '(UTC+02:00) Tripoli',
		text2: 'LST - Libya Standard Time',
		utc: ['Africa/Tripoli'],
	},
	{
		value: 'Jordan Standard Time',
		abbr: 'JST',
		offset: 3,
		isdst: false,
		text: '(UTC+03:00) Amman',
		text2: 'JST - Jordan Standard Time',
		utc: ['Asia/Amman'],
	},
	{
		value: 'Arabic Standard Time',
		abbr: 'ASTa',
		offset: 3,
		isdst: false,
		text: '(UTC+03:00) Baghdad',
		text2: 'AST - Arabic Standard Time',
		utc: ['Asia/Baghdad'],
	},
	{
		value: 'Kaliningrad Standard Time',
		abbr: 'KST',
		offset: 3,
		isdst: false,
		text: '(UTC+02:00) Kaliningrad',
		text2: 'KST - Kaliningrad Standard Time',
		utc: ['Europe/Kaliningrad'],
	},
	{
		value: 'Arab Standard Time',
		abbr: 'ASTa',
		offset: 3,
		isdst: false,
		text: '(UTC+03:00) Kuwait, Riyadh',
		text2: 'AST - Arab Standard Time',
		utc: [
			'Asia/Aden',
			'Asia/Bahrain',
			'Asia/Kuwait',
			'Asia/Qatar',
			'Asia/Riyadh',
		],
	},
	{
		value: 'E. Africa Standard Time',
		abbr: 'EAST',
		offset: 3,
		isdst: false,
		text: '(UTC+03:00) Nairobi',
		text2: 'EAST - E. Africa Standard Time',
		utc: [
			'Africa/Addis_Ababa',
			'Africa/Asmera',
			'Africa/Dar_es_Salaam',
			'Africa/Djibouti',
			'Africa/Juba',
			'Africa/Kampala',
			'Africa/Khartoum',
			'Africa/Mogadishu',
			'Africa/Nairobi',
			'Antarctica/Syowa',
			'Etc/GMT-3',
			'Indian/Antananarivo',
			'Indian/Comoro',
			'Indian/Mayotte',
		],
	},
	{
		value: 'Moscow Standard Time',
		abbr: 'MSK',
		offset: 3,
		isdst: false,
		text: '(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk',
		text2: 'MSK - Moscow Standard Time',
		utc: [
			'Europe/Kirov',
			'Europe/Moscow',
			'Europe/Simferopol',
			'Europe/Volgograd',
			'Europe/Minsk',
		],
	},
	{
		value: 'Samara Time',
		abbr: 'SAMT',
		offset: 4,
		isdst: false,
		text: '(UTC+04:00) Samara, Ulyanovsk, Saratov',
		text2: 'SAMT - Samara Time',
		utc: ['Europe/Astrakhan', 'Europe/Samara', 'Europe/Ulyanovsk'],
	},
	{
		value: 'Iran Standard Time',
		abbr: 'IDT',
		offset: 4.5,
		isdst: true,
		text: '(UTC+03:30) Tehran',
		text2: 'IDT - Iran Standard Time',
		utc: ['Asia/Tehran'],
	},
	{
		value: 'Arabian Standard Time',
		abbr: 'ASTa',
		offset: 4,
		isdst: false,
		text: '(UTC+04:00) Abu Dhabi, Muscat',
		text2: 'AST - Arabian Standard Time',
		utc: ['Asia/Dubai', 'Asia/Muscat', 'Etc/GMT-4'],
	},
	{
		value: 'Azerbaijan Standard Time',
		abbr: 'ADT',
		offset: 5,
		isdst: true,
		text: '(UTC+04:00) Baku',
		text2: 'ADT - Azerbaijan Standard Time',
		utc: ['Asia/Baku'],
	},
	{
		value: 'Mauritius Standard Time',
		abbr: 'MST',
		offset: 4,
		isdst: false,
		text: '(UTC+04:00) Port Louis',
		text2: 'MST - Mauritius Standard Time',
		utc: ['Indian/Mahe', 'Indian/Mauritius', 'Indian/Reunion'],
	},
	{
		value: 'Georgian Standard Time',
		abbr: 'GET',
		offset: 4,
		isdst: false,
		text: '(UTC+04:00) Tbilisi',
		text2: 'GET - Georgian Standard Time',
		utc: ['Asia/Tbilisi'],
	},
	{
		value: 'Caucasus Standard Time',
		abbr: 'CST',
		offset: 4,
		isdst: false,
		text: '(UTC+04:00) Yerevan',
		text2: 'CST - Caucasus Standard Time',
		utc: ['Asia/Yerevan'],
	},
	{
		value: 'Afghanistan Standard Time',
		abbr: 'ASTa',
		offset: 4.5,
		isdst: false,
		text: '(UTC+04:30) Kabul',
		text2: 'AST - Afghanistan Standard Time',
		utc: ['Asia/Kabul'],
	},
	{
		value: 'West Asia Standard Time',
		abbr: 'WAST',
		offset: 5,
		isdst: false,
		text: '(UTC+05:00) Ashgabat, Tashkent',
		text2: 'WAST - West Asia Standard Time',
		utc: [
			'Antarctica/Mawson',
			'Asia/Aqtau',
			'Asia/Aqtobe',
			'Asia/Ashgabat',
			'Asia/Dushanbe',
			'Asia/Oral',
			'Asia/Samarkand',
			'Asia/Tashkent',
			'Etc/GMT-5',
			'Indian/Kerguelen',
			'Indian/Maldives',
		],
	},
	{
		value: 'Yekaterinburg Time',
		abbr: 'YEKT',
		offset: 5,
		isdst: false,
		text: '(UTC+05:00) Yekaterinburg',
		text2: 'YEKT - Yekaterinburg Time',
		utc: ['Asia/Yekaterinburg'],
	},
	{
		value: 'Pakistan Standard Time',
		abbr: 'PKT',
		offset: 5,
		isdst: false,
		text: '(UTC+05:00) Islamabad, Karachi',
		text2: 'PKT - Pakistan Standard Time',
		utc: ['Asia/Karachi'],
	},
	{
		value: 'India Standard Time',
		abbr: 'IST',
		offset: 5.5,
		isdst: false,
		text: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
		text2: 'IST - India Standard Time',
		utc: ['Asia/Kolkata', 'Asia/Calcutta'],
	},
	{
		value: 'Sri Lanka Standard Time',
		abbr: 'SLST',
		offset: 5.5,
		isdst: false,
		text: '(UTC+05:30) Sri Jayawardenepura',
		text2: 'SLST - Sri Lanka Standard Time',
		utc: ['Asia/Colombo'],
	},
	{
		value: 'Nepal Standard Time',
		abbr: 'NST',
		offset: 5.75,
		isdst: false,
		text: '(UTC+05:45) Kathmandu',
		text2: 'NST - Nepal Standard Time',
		utc: ['Asia/Kathmandu'],
	},
	{
		value: 'Central Asia Standard Time',
		abbr: 'CAST',
		offset: 6,
		isdst: false,
		text: '(UTC+06:00) Nur-Sultan (Astana)',
		text2: 'CAST - Central Asia Standard Time',
		utc: [
			'Antarctica/Vostok',
			'Asia/Almaty',
			'Asia/Bishkek',
			'Asia/Qyzylorda',
			'Asia/Urumqi',
			'Etc/GMT-6',
			'Indian/Chagos',
		],
	},
	{
		value: 'Bangladesh Standard Time',
		abbr: 'BST',
		offset: 6,
		isdst: false,
		text: '(UTC+06:00) Dhaka',
		text2: 'BST - Bangladesh Standard Time',
		utc: ['Asia/Dhaka', 'Asia/Thimphu'],
	},
	{
		value: 'Myanmar Standard Time',
		abbr: 'MST',
		offset: 6.5,
		isdst: false,
		text: '(UTC+06:30) Yangon (Rangoon)',
		text2: 'MST - Myanmar Standard Time',
		utc: ['Asia/Rangoon', 'Indian/Cocos'],
	},
	{
		value: 'SE Asia Standard Time',
		abbr: 'SAST',
		offset: 7,
		isdst: false,
		text: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
		text2: 'SAST - SE Asia Standard Time',
		utc: [
			'Antarctica/Davis',
			'Asia/Bangkok',
			'Asia/Hovd',
			'Asia/Jakarta',
			'Asia/Phnom_Penh',
			'Asia/Pontianak',
			'Asia/Saigon',
			'Asia/Vientiane',
			'Etc/GMT-7',
			'Indian/Christmas',
		],
	},
	{
		value: 'N. Central Asia Standard Time',
		abbr: 'NCAST',
		offset: 7,
		isdst: false,
		text: '(UTC+07:00) Novosibirsk',
		text2: 'NCAST - N. Central Asia Standard Time',
		utc: ['Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk'],
	},
	{
		value: 'China Standard Time',
		abbr: 'CST',
		offset: 8,
		isdst: false,
		text: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
		text2: 'CST - China Standard Time',
		utc: ['Asia/Hong_Kong', 'Asia/Macau', 'Asia/Shanghai'],
	},
	{
		value: 'North Asia Standard Time',
		abbr: 'NAST',
		offset: 8,
		isdst: false,
		text: '(UTC+08:00) Krasnoyarsk',
		text2: 'NAST - North Asia Standard Time',
		utc: ['Asia/Krasnoyarsk'],
	},
	{
		value: 'Singapore Standard Time',
		abbr: 'MPST',
		offset: 8,
		isdst: false,
		text: '(UTC+08:00) Kuala Lumpur, Singapore',
		text2: 'MPST - Singapore Standard Time',
		utc: [
			'Asia/Brunei',
			'Asia/Kuala_Lumpur',
			'Asia/Kuching',
			'Asia/Makassar',
			'Asia/Manila',
			'Asia/Singapore',
			'Etc/GMT-8',
		],
	},
	{
		value: 'W. Australia Standard Time',
		abbr: 'WAST',
		offset: 8,
		isdst: false,
		text: '(UTC+08:00) Perth',
		text2: 'WAST - W. Australia Standard Time',
		utc: ['Antarctica/Casey', 'Australia/Perth'],
	},
	{
		value: 'Taipei Standard Time',
		abbr: 'TST',
		offset: 8,
		isdst: false,
		text: '(UTC+08:00) Taipei',
		text2: 'TST - Taipei Standard Time',
		utc: ['Asia/Taipei'],
	},
	{
		value: 'Ulaanbaatar Standard Time',
		abbr: 'UST',
		offset: 8,
		isdst: false,
		text: '(UTC+08:00) Ulaanbaatar',
		text2: 'UST - Ulaanbaatar Standard Time',
		utc: ['Asia/Choibalsan', 'Asia/Ulaanbaatar'],
	},
	{
		value: 'North Asia East Standard Time',
		abbr: 'NAEST',
		offset: 8,
		isdst: false,
		text: '(UTC+08:00) Irkutsk',
		text2: 'NAEST - North Asia East Standard Time',
		utc: ['Asia/Irkutsk'],
	},
	{
		value: 'Japan Standard Time',
		abbr: 'JST',
		offset: 9,
		isdst: false,
		text: '(UTC+09:00) Osaka, Sapporo, Tokyo',
		text2: 'JST - Japan Standard Time',
		utc: [
			'Asia/Dili',
			'Asia/Jayapura',
			'Asia/Tokyo',
			'Etc/GMT-9',
			'Pacific/Palau',
		],
	},
	{
		value: 'Korea Standard Time',
		abbr: 'KST',
		offset: 9,
		isdst: false,
		text: '(UTC+09:00) Seoul',
		text2: 'KST - Korea Standard Time',
		utc: ['Asia/Pyongyang', 'Asia/Seoul'],
	},
	{
		value: 'Cen. Australia Standard Time',
		abbr: 'CAST',
		offset: 9.5,
		isdst: false,
		text: '(UTC+09:30) Adelaide',
		text2: 'CAST - Cen. Australia Standard Time',
		utc: ['Australia/Adelaide', 'Australia/Broken_Hill'],
	},
	{
		value: 'AUS Central Standard Time',
		abbr: 'ACST',
		offset: 9.5,
		isdst: false,
		text: '(UTC+09:30) Darwin',
		text2: 'ACST - AUS Central Standard Time',
		utc: ['Australia/Darwin'],
	},
	{
		value: 'E. Australia Standard Time',
		abbr: 'EAST',
		offset: 10,
		isdst: false,
		text: '(UTC+10:00) Brisbane',
		text2: 'EAST - E. Australia Standard Time',
		utc: ['Australia/Brisbane', 'Australia/Lindeman'],
	},
	{
		value: 'AUS Eastern Standard Time',
		abbr: 'AEST',
		offset: 10,
		isdst: false,
		text: '(UTC+10:00) Canberra, Melbourne, Sydney',
		text2: 'AEST - AUS Eastern Standard Time',
		utc: ['Australia/Melbourne', 'Australia/Sydney'],
	},
	{
		value: 'West Pacific Standard Time',
		abbr: 'WPST',
		offset: 10,
		isdst: false,
		text: '(UTC+10:00) Guam, Port Moresby',
		text2: 'WPST - West Pacific Standard Time',
		utc: [
			'Antarctica/DumontDUrville',
			'Etc/GMT-10',
			'Pacific/Guam',
			'Pacific/Port_Moresby',
			'Pacific/Saipan',
			'Pacific/Truk',
		],
	},
	{
		value: 'Tasmania Standard Time',
		abbr: 'TST',
		offset: 10,
		isdst: false,
		text: '(UTC+10:00) Hobart',
		text2: 'TST - Tasmania Standard Time',
		utc: ['Australia/Currie', 'Australia/Hobart'],
	},
	{
		value: 'Yakutsk Standard Time',
		abbr: 'YST',
		offset: 9,
		isdst: false,
		text: '(UTC+09:00) Yakutsk',
		text2: 'YST - Yakutsk Standard Time',
		utc: ['Asia/Chita', 'Asia/Khandyga', 'Asia/Yakutsk'],
	},
	{
		value: 'Central Pacific Standard Time',
		abbr: 'CPST',
		offset: 11,
		isdst: false,
		text: '(UTC+11:00) Solomon Is., New Caledonia',
		text2: 'CPST - Central Pacific Standard Time',
		utc: [
			'Antarctica/Macquarie',
			'Etc/GMT-11',
			'Pacific/Efate',
			'Pacific/Guadalcanal',
			'Pacific/Kosrae',
			'Pacific/Noumea',
			'Pacific/Ponape',
		],
	},
	{
		value: 'Vladivostok Standard Time',
		abbr: 'VST',
		offset: 11,
		isdst: false,
		text: '(UTC+11:00) Vladivostok',
		text2: 'VST - Vladivostok Standard Time',
		utc: ['Asia/Sakhalin', 'Asia/Ust-Nera', 'Asia/Vladivostok'],
	},
	{
		value: 'New Zealand Standard Time',
		abbr: 'NZST',
		offset: 12,
		isdst: false,
		text: '(UTC+12:00) Auckland, Wellington',
		text2: 'NZST - New Zealand Standard Time',
		utc: ['Antarctica/McMurdo', 'Pacific/Auckland'],
	},
	{
		value: 'UTC+12',
		abbr: 'U',
		offset: 12,
		isdst: false,
		text: '(UTC+12:00) Coordinated Universal Time+12',
		text2: 'U - UTC+12',
		utc: [
			'Etc/GMT-12',
			'Pacific/Funafuti',
			'Pacific/Kwajalein',
			'Pacific/Majuro',
			'Pacific/Nauru',
			'Pacific/Tarawa',
			'Pacific/Wake',
			'Pacific/Wallis',
		],
	},
	{
		value: 'Fiji Standard Time',
		abbr: 'FST',
		offset: 12,
		isdst: false,
		text: '(UTC+12:00) Fiji',
		text2: 'FST - Fiji Standard Time',
		utc: ['Pacific/Fiji'],
	},
	{
		value: 'Magadan Standard Time',
		abbr: 'MST',
		offset: 12,
		isdst: false,
		text: '(UTC+12:00) Magadan',
		text2: 'MST - Magadan Standard Time',
		utc: [
			'Asia/Anadyr',
			'Asia/Kamchatka',
			'Asia/Magadan',
			'Asia/Srednekolymsk',
		],
	},
	{
		value: 'Kamchatka Standard Time',
		abbr: 'KDT',
		offset: 13,
		isdst: true,
		text: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
		text2: 'KDT - Kamchatka Standard Time',
		utc: ['Asia/Kamchatka'],
	},
	{
		value: 'Tonga Standard Time',
		abbr: 'TST',
		offset: 13,
		isdst: false,
		text: "(UTC+13:00) Nuku'alofa",
		text2: 'TST - Tonga Standard Time',
		utc: [
			'Etc/GMT-13',
			'Pacific/Enderbury',
			'Pacific/Fakaofo',
			'Pacific/Tongatapu',
		],
	},
	{
		value: 'Samoa Standard Time',
		abbr: 'SST',
		offset: 13,
		isdst: false,
		text: '(UTC+13:00) Samoa',
		text2: 'SST - Samoa Standard Time',
		utc: ['Pacific/Apia'],
	},
];

export const AUTH_MODULES = [
	{
		name: 'Admin Campaigns',
		path: 'admin/campaigns',
		visible: true,
		all: false,
	},
	{ name: 'Billing', path: 'admin/billing', visible: true, all: false },
	{
		name: 'Employee Users',
		path: 'admin/employee-users',
		visible: true,
		all: false,
	},
	{
		name: 'Client Users',
		path: 'admin/client-users',
		visible: true,
		all: false,
	},
	{ name: 'QC Control', path: 'admin/leads', visible: true, all: false },
	{
		name: 'Forecast Range',
		path: 'admin/forecast-range',
		visible: true,
		all: false,
	},
	{
		name: 'Forecast Month',
		path: 'admin/forecast-month',
		visible: true,
		all: false,
	},
	{
		name: 'Forecasst Week',
		path: 'admin/forecast-week',
		visible: true,
		all: false,
	},
	{
		name: 'Black Out Days',
		path: 'admin/black-out-days',
		visible: true,
		all: false,
	},
	{
		name: 'Reschedule Leads',
		path: 'admin/reschedule-leads',
		visible: true,
		all: false,
	},
	{
		name: 'Replacement Leads',
		path: 'admin/replacement-leads',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Feedback',
		path: 'admin/customer-feedback',
		visible: true,
		all: false,
	},
	{
		name: 'Report Feedback',
		path: 'admin/report-feedback',
		visible: true,
		all: false,
	},
	{
		name: 'Login History',
		path: 'admin/history-login',
		visible: true,
		all: false,
	},
	{ name: 'Reports', path: 'admin/reports', visible: true, all: false },
	{
		name: 'Employee Reports',
		path: 'admin/employee-reports',
		visible: true,
		all: false,
	},
	{
		name: 'Lead Report',
		path: 'admin/lead-report',
		visible: true,
		all: false,
	},
	{ name: 'Dashboard', path: 'admin/dashboard', visible: true, all: false },
	{ name: 'Edit Users', path: 'admin/user-edit', visible: true, all: false },
	{
		name: 'Upload Prospects',
		path: 'admin/upload-prospects',
		visible: true,
		all: false,
	},
	{
		name: 'Edit Campaign',
		path: 'admin/campaign-edit',
		visible: true,
		all: false,
	},
	{ name: 'Payments', path: 'admin/payments', visible: true, all: false },
	{
		name: 'Call Report',
		path: 'admin/call-report',
		visible: true,
		all: false,
	},
	{
		name: 'Caller Overview',
		path: 'admin/caller-overview',
		visible: true,
		all: false,
	},
	{
		name: 'Dispo Report',
		path: 'admin/dispo-report',
		visible: true,
		all: false,
	},

	{
		name: 'Caller Campaigns',
		path: 'caller/campaigns',
		visible: true,
		all: false,
	},
	{ name: 'Search', path: 'caller/search', visible: true, all: false },
	{ name: 'DB Reset', path: 'caller/dbreset', visible: true, all: false },
	{ name: 'Dispos', path: 'caller/dispo', visible: true, all: false },
	{
		name: 'Calling View',
		path: 'caller/lead-profile',
		visible: true,
		all: false,
	},

	{
		name: 'Customer Leads',
		path: 'customer/leads',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Calendar',
		path: 'customer/calendar',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Black Out Days',
		path: 'customer/black-out-days',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Account Review',
		path: 'customer/account-review',
		visible: true,
		all: false,
	},

	{
		name: 'Developer Options',
		path: 'developer/options',
		visible: true,
		all: false,
	},
	{ name: 'Add Campaign', path: 'campaign-add', visible: true, all: false },
	{
		name: 'Edit Lead',
		path: 'lead-edit/:selectedLead',
		visible: true,
		all: false,
	},
	{ name: 'Login', path: 'login', visible: false, all: false },
	{
		name: 'Campaign Calendar',
		path: 'campaign-calendar/:id',
		visible: true,
		all: false,
	},
	{
		name: 'All Campaigns Calendar',
		path: 'all-campaign-calendar',
		visible: true,
		all: false,
	},
	{ name: 'Default', path: '', visible: false, all: true },
	{
		name: 'Not Authorized',
		path: 'not-authorized',
		visible: true,
		all: false,
	},
];

export const QC_THEADS = [
	{
		text: 'Id',
		key: 'id',
		visible: true,
		type: 'number',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Creation date',
		key: 'lead_creation',
		visible: true,
		type: 'mediumDate',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Agent',
		key: 'generated_by',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-10',
	},
	{
		text: 'Appt Date',
		key: 'date_generated',
		visible: true,
		type: 'medium',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Time Zone',
		key: 'time_zone',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Phone',
		key: 'primary_phone',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-10',
	},
	{
		text: 'Prospect',
		key: 'prospect_company',
		visible: true,
		type: 'string',
		order: '',
		align: 'left',
		cell_class: [],
		icon: 'fa fa-hand-pointer-o',
		width: 'tcol-25',
	},
	{
		text: 'Status',
		key: 'replacement_status',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [
			{
				value: 'Approved',
				class: 'bg-success',
				operator: '==',
			},
		],
		width: 'tcol-25',
	},
	{
		text: 'Replaced by',
		key: 'replaced_by',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		width: 'tcol-25',
	},
	{
		text: 'Replaced for',
		key: 'replace_for',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		width: 'tcol-25',
	},
	{
		text: 'Meet Type',
		key: 'meet_type',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Difficulty',
		key: 'difficult',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Qualified',
		key: 'calificado',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		width: 'tcol-25',
	},
	{
		text: 'Campaign',
		key: 'campaign_name',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Billed',
		key: 'payed',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Free type',
		key: 'free_type',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Confirmation',
		key: 'confirmation',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Prospect Name',
		key: 'prospect_name',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'City',
		key: 'city',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'State',
		key: 'state',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Zip',
		key: 'zip',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Email',
		key: 'primary_email',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Employee Size',
		key: 'employee_size',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Time In status',
		key: 'change_date',
		visible: false,
		type: 'dateAgo',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-20',
	},
];
